import { Badge } from '@ibsys/kit';
import { FC } from 'react';
import { cn, DOWNLOAD_FORMAT_BADGE_CLASS, DOWNLOAD_FORMATS, type FileDownloadFormat } from '@/shared/lib';

type Props = {
  /** Скачивание в выбранном формате */
  onSelect: (format: FileDownloadFormat) => void;
  /** Подпись для чтения с экрана; без неё лейбл читается собственным текстом */
  getAriaLabel?: (format: FileDownloadFormat) => string;
  /** Префикс идентификатора лейбла для тестов; к нему добавляется сам формат */
  testIdPrefix?: string;
  /** Классы строки лейблов */
  className?: string;
};

/**
 * Строка лейблов форматов из общего перечня {@link DOWNLOAD_FORMATS}: выбор формата —
 * это клик по лейблу, отдельного действия «скачать» рядом нет. Единственное место, где
 * лейблы форматов собираются в строку, — иначе вид формата пришлось бы править у каждого
 * места скачивания отдельно.
 */
export const DownloadFormatBadges: FC<Props> = ({ onSelect, getAriaLabel, testIdPrefix, className }) => (
  <span className={cn('flex shrink-0 gap-1', className)}>
    {DOWNLOAD_FORMATS.map((format) => (
      <Badge
        key={format}
        asChild
        variant="secondary"
        outline
        className={cn('cursor-pointer', DOWNLOAD_FORMAT_BADGE_CLASS[format])}
      >
        <button
          type="button"
          aria-label={getAriaLabel?.(format)}
          data-testid={testIdPrefix ? `${testIdPrefix}-${format}` : undefined}
          onClick={() => onSelect(format)}
        >
          {format}
        </button>
      </Badge>
    ))}
  </span>
);
